// extracted by mini-css-extract-plugin
export var chevron = "_1g-d";
export var disabled = "_1g-b";
export var error = "_1g-c";
export var hideBorder = "_1g-1";
export var icon = "_1g-e";
export var input = "_1g-0";
export var large = "_1g-f";
export var open = "_1g-9";
export var placeholder = "_1g-a";
export var regular = "_1g-5";
export var singleRowInput = "_1g-2";
export var singleSelectInput = "_1g-3 _1g-0";
export var small = "_1g-4";
export var spinnerContainer = "_1g-i";
export var tag = "_1g-7";
export var tagsContainer = "_1g-8";
export var tagsInput = "_1g-6 _1g-0";
export var xSmall = "_1g-g";
export var xxSmall = "_1g-h";